export default function ListingsSection() {
  const myListings = [
    {
      id: 1,
      title: "Foresthill",
      price: "$160,000",
      address: "20676 Spring Garden Rd",
      location: "Foresthill, CA 95631",
      type: "Land",
      lotSize: "11.9 Acres",
      image: "https://public.readdy.ai/ai/img_res/f3dcfb6267a6a87ad03f27087573930c.jpg",
      label: "Just Listed",
      mls: "225144727",
      url: "https://jefferylong.exprealty.com/property/47-225144727-20676-spring-garden-rd-foresthill-CA-95631"
    }
  ];

  const justListed = [
    {
      id: 1,
      title: "Auburn",
      price: "$147,000",
      address: "3765 Grass Valley Highway # 213",
      location: "Auburn, CA 95603",
      type: "Manufactured",
      size: "1,488 SqFt",
      beds: 3,
      baths: 2,
      image: "https://readdy.ai/api/search-image?query=Manufactured%20home%20in%20Auburn%20California%2C%20mobile%20home%20community%2C%20well-maintained%20manufactured%20housing%2C%20residential%20property%20with%20landscaping%20and%20parking&width=400&height=300&seq=auburn-manu-001&orientation=landscape",
      label: "Just Listed",
      url: "https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types%5B%5D=1&types%5B%5D=2&types%5B%5D=4&types%5B%5D=8&types%5B%5D=9&types%5B%5D=15&types%5B%5D=18&types%5B%5D=31&types%5B%5D=32&types%5B%5D=5&types%5B%5D=20&beds=0&baths=0&min=0&max=100000000&rtype=map#rslt"
    },
    {
      id: 2,
      title: "Citrus Heights",
      price: "$239,000",
      address: "6436 Bremen Drive # 3",
      location: "Citrus Heights, CA 95621",
      type: "Condos",
      size: "840 SqFt",
      beds: 2,
      baths: 1,
      image: "https://readdy.ai/api/search-image?query=Condominium%20in%20Citrus%20Heights%20California%2C%20modern%20condo%20exterior%2C%20residential%20complex%20with%20parking%2C%20well-maintained%20property%20with%20landscaping&width=400&height=300&seq=citrus-condo-001&orientation=landscape",
      label: "Open House",
      url: "https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types%5B%5D=1&types%5B%5D=2&types%5B%5D=4&types%5B%5D=8&types%5B%5D=9&types%5B%5D=15&types%5B%5D=18&types%5B%5D=31&types%5B%5D=32&types%5B%5D=5&types%5B%5D=20&beds=0&baths=0&min=0&max=100000000&rtype=map#rslt"
    },
    {
      id: 3,
      title: "Cool",
      price: "$759,000",
      address: "2060 Onion Flat Court",
      location: "Cool, CA 95614",
      type: "Single Family",
      size: "2,858 SqFt",
      beds: 3,
      baths: 3,
      image: "https://readdy.ai/api/search-image?query=Single%20family%20home%20in%20Cool%20California%2C%20residential%20house%20exterior%2C%20modern%20home%20with%20driveway%20and%20landscaping%2C%20well-maintained%20property%20in%20suburban%20setting&width=400&height=300&seq=cool-house-001&orientation=landscape",
      label: "Just Listed",
      url: "https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types%5B%5D=1&types%5B%5D=2&types%5B%5D=4&types%5B%5D=8&types%5B%5D=9&types%5B%5D=15&types%5B%5D=18&types%5B%5D=31&types%5B%5D=32&types%5B%5D=5&types%5B%5D=20&beds=0&baths=0&min=0&max=100000000&rtype=map#rslt"
    }
  ];

  const justReduced = [
    {
      id: 1,
      title: "Colfax",
      price: "$129,000",
      address: "416 Rubicon Court",
      location: "Colfax, CA 95713",
      type: "Land",
      lotSize: "0.745 Acres",
      image: "https://readdy.ai/api/search-image?query=Land%20lot%20in%20Colfax%20California%2C%20vacant%20property%20for%20development%2C%20natural%20landscape%20with%20trees%2C%20undeveloped%20residential%20lot%20for%20sale&width=400&height=300&seq=colfax-land-001&orientation=landscape",
      label: "Reduced",
      url: "https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types%5B%5D=1&types%5B%5D=2&types%5B%5D=4&types%5B%5D=8&types%5B%5D=9&types%5B%5D=15&types%5B%5D=18&types%5B%5D=31&types%5B%5D=32&types%5B%5D=5&types%5B%5D=20&beds=0&baths=0&min=0&max=100000000&rtype=map#rslt"
    },
    {
      id: 2,
      title: "Angels Camp",
      price: "$450,000",
      address: "615-617 Tuolumne Avenue",
      location: "Angels Camp, CA 95222",
      type: "Income",
      size: "884 SqFt",
      beds: 2,
      baths: 1,
      image: "https://readdy.ai/api/search-image?query=Income%20property%20in%20Angels%20Camp%20California%2C%20duplex%20or%20rental%20property%2C%20residential%20building%20with%20multiple%20units%2C%20investment%20property%20exterior&width=400&height=300&seq=angels-income-001&orientation=landscape",
      label: "Reduced",
      url: "https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types%5B%5D=1&types%5B%5D=2&types%5B%5D=4&types%5B%5D=8&types%5B%5D=9&types%5B%5D=15&types%5B%5D=18&types%5B%5D=31&types%5B%5D=32&types%5B%5D=5&types%5B%5D=20&beds=0&baths=0&min=0&max=100000000&rtype=map#rslt"
    },
    {
      id: 3,
      title: "Carmichael",
      price: "$530,000",
      address: "5516 Barbara Way",
      location: "Carmichael, CA 95608",
      type: "Single Family",
      size: "2,400 SqFt",
      beds: 4,
      baths: 2,
      image: "https://readdy.ai/api/search-image?query=Single%20family%20home%20in%20Carmichael%20California%2C%20residential%20house%20exterior%2C%20suburban%20home%20with%20front%20yard%20and%20driveway%2C%20well-maintained%20property&width=400&height=300&seq=carmichael-house-001&orientation=landscape",
      label: "Open House",
      url: "https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types%5B%5D=1&types%5B%5D=2&types%5B%5D=4&types%5B%5D=8&types%5B%5D=9&types%5B%5D=15&types%5B%5D=18&types%5B%5D=31&types%5B%5D=32&types%5B%5D=5&types%5B%5D=20&beds=0&baths=0&min=0&max=100000000&rtype=map#rslt"
    }
  ];

  const PropertyCard = ({ property }: { property: any }) => (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden group">
      <div className="relative">
        <a 
          href={property.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          <img 
            src={property.image}
            alt={property.title}
            className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300 cursor-pointer"
          />
        </a>
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-1 text-xs font-semibold rounded ${
            property.label === 'Just Listed' ? 'bg-green-600 text-white' :
            property.label === 'Open House' ? 'bg-blue-600 text-white' :
            'bg-red-600 text-white'
          }`}>
            {property.label}
          </span>
        </div>
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="flex flex-col space-y-1">
            <button className="bg-white bg-opacity-90 p-2 rounded-full hover:bg-opacity-100 transition-colors">
              <i className="fa fa-search text-gray-700"></i>
            </button>
            <button className="bg-white bg-opacity-90 p-2 rounded-full hover:bg-opacity-100 transition-colors">
              <i className="fa fa-heart text-gray-700"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-lg font-semibold">{property.title}</h3>
          <p className="text-xl font-bold text-blue-600">{property.price}</p>
        </div>
        <div className="text-gray-600 mb-3">
          <p className="flex items-center text-sm">
            <i className="fa fa-map-marker mr-1"></i>
            {property.address}
          </p>
          <p className="text-sm">{property.location}</p>
        </div>
        <div className="text-sm text-gray-700">
          <div className="flex justify-between">
            <span>Type:</span>
            <span>{property.type}</span>
          </div>
          {property.size && (
            <div className="flex justify-between">
              <span>Size:</span>
              <span>{property.size}</span>
            </div>
          )}
          {property.lotSize && (
            <div className="flex justify-between">
              <span>Lot Size:</span>
              <span>{property.lotSize}</span>
            </div>
          )}
          {property.beds && property.baths && (
            <div className="flex justify-between">
              <span>Rooms:</span>
              <span>{property.beds} Beds + {property.baths} Baths</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* My Listings */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold">
              <a 
                href="https://jefferylong.exprealty.com/index.php?showagent=1#rslt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-blue-600 transition-colors"
              >
                My Listings
              </a>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {myListings.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        </div>

        {/* Just Listed */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold">
              <a 
                href="https://jefferylong.exprealty.com/index.php?quick=1&display=&custombox=&types[]=1&types[]=2&types[]=4&types[]=8&types[]=9&types[]=15&types[]=18&types[]=31&types[]=32&types[]=55&types[]=56&types[]=5&types[]=20&beds=0&baths=0&min=0&max=100000000&minfootage=0&maxfootage=30000&minacres=0&maxacres=50000&yearbuilt=0&walkscore=0&options[]=new&keywords=&rtype=grid&sortby=listings.price+DESC#rslt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-blue-600 transition-colors"
              >
                Just Listed
              </a>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {justListed.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        </div>

        {/* Just Reduced */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold">
              <a 
                href="https://jefferylong.exprealty.com/index.php?quick=1&display=&custombox=&types[]=1&types[]=2&types[]=4&types[]=8&types[]=9&types[]=15&types[]=18&types[]=31&types[]=32&types[]=55&types[]=56&types[]=5&types[]=20&beds=0&baths=0&min=0&max=100000000&minfootage=0&maxfootage=30000&minacres=0&maxacres=50000&yearbuilt=0&walkscore=0&options[]=reduced&keywords=&rtype=grid&sortby=listings.price+DESC#rslt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-blue-600 transition-colors"
              >
                Just Reduced
              </a>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {justReduced.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        </div>

        {/* Additional Content Sections */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Real%20estate%20listing%20alerts%20notification%20on%20smartphone%2C%20mobile%20app%20interface%2C%20property%20search%20technology%2C%20modern%20real%20estate%20digital%20tools%2C%20home%20search%20alerts&width=600&height=400&seq=listing-alerts-001&orientation=landscape"
              alt="Instant Listing Alerts"
              className="w-full h-64 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-3">Instant Listing Alerts</h3>
              <p className="text-gray-600 mb-4">
                Subscribe and receive instant Listing alerts as soon as your Dream Home hits the market. Create a Free Account today and receive updated Market Reports surrounding highly desired communities.
              </p>
              <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap">
                Subscribe Now
              </button>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Real%20estate%20market%20report%20charts%20and%20graphs%2C%20housing%20market%20analysis%2C%20property%20value%20trends%2C%20professional%20market%20data%20visualization%2C%20real%20estate%20statistics&width=600&height=400&seq=market-report-001&orientation=landscape"
              alt="Market Report"
              className="w-full h-64 object-cover object-top"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-3">Stay on top of your local Real Estate market</h3>
              <p className="text-gray-600 mb-4">
                Get a FREE Market Report that outlines the average listing price, price reductions, new listings, and more!
              </p>
              <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap">
                Get Free Report
              </button>
            </div>
          </div>
        </div>

        {/* Single Column Sections */}
        <div className="space-y-8">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-8 flex items-center">
                <div className="max-w-lg mx-auto">
                  <h3 className="text-2xl font-semibold mb-4">Get Pre-Approved</h3>
                  <p className="text-gray-600 mb-6">
                    Our partners offer low rates, low fees, and local underwriting, so we can close loans quickly.
                  </p>
                  <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap">
                    Start Application
                  </button>
                </div>
              </div>
              <img 
                src="https://readdy.ai/api/search-image?query=Mortgage%20pre-approval%20calculator%20and%20documents%2C%20home%20financing%20paperwork%2C%20real%20estate%20loan%20application%20process%2C%20professional%20mortgage%20consultation%20setup&width=600&height=400&seq=preapproval-001&orientation=landscape"
                alt="Get Pre-Approved"
                className="w-full h-64 lg:h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <img 
                src="https://readdy.ai/api/search-image?query=Person%20reading%20real%20estate%20blog%20on%20laptop%2C%20home%20buying%20and%20selling%20tips%2C%20real%20estate%20education%20content%2C%20professional%20real%20estate%20advice%20and%20resources&width=600&height=400&seq=blog-resources-001&orientation=landscape"
                alt="Blog Resources"
                className="w-full h-64 lg:h-full object-cover object-top"
              />
              <div className="p-8 flex items-center">
                <div className="max-w-lg mx-auto">
                  <h3 className="text-2xl font-semibold mb-4">Find Valuable Resources on Our Blog</h3>
                  <p className="text-gray-600 mb-6">
                    Search helpful articles that cover Buyer and Seller tips and tricks to save thousands of dollars.
                  </p>
                  <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap">
                    Start Reading
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Widgets */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-lg overflow-hidden shadow-lg">
            <div className="p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-4">What's My Home Worth?</h3>
              <button className="bg-white text-purple-600 px-6 py-2 rounded-md font-medium hover:bg-gray-100 transition-colors whitespace-nowrap">
                Find Out More
              </button>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-lg overflow-hidden shadow-lg">
            <div className="p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-4">Open Houses</h3>
              <button className="bg-white text-orange-600 px-6 py-2 rounded-md font-medium hover:bg-gray-100 transition-colors whitespace-nowrap">
                View Homes
              </button>
            </div>
          </div>
        </div>

        {/* Off-Market Listings Section */}
        <div className="mt-16 bg-gradient-to-r from-gray-900 to-gray-800 rounded-lg overflow-hidden shadow-lg">
          <div className="p-8 text-white text-center">
            <h3 className="text-3xl font-bold mb-4">Exclusive Off-Market Listings</h3>
            <p className="text-lg mb-6 text-gray-300">
              Get access to exclusive properties not available to the general public. 
              These premium listings are shared only with our VIP clients.
            </p>
            <form 
              id="off-market-form"
              data-readdy-form
              action="https://readdy.ai/api/form/d4d78h2els5gugpjmkp0"
              method="POST"
              className="max-w-md mx-auto space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.target as HTMLFormElement;
                const formData = new FormData(form);
                
                fetch('https://readdy.ai/api/form/d4d78h2els5gugpjmkp0', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString()
                })
                .then(() => {
                  alert('Request submitted successfully! We will contact you soon with exclusive listings.');
                  form.reset();
                })
                .catch(() => {
                  alert('There was an error submitting your request. Please try again.');
                });
              }}
            >
              <input 
                type="email" 
                name="email"
                placeholder="Enter your email address"
                required
                className="w-full px-4 py-3 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input 
                type="text" 
                name="name"
                placeholder="Your full name"
                required
                className="w-full px-4 py-3 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input 
                type="tel" 
                name="phone"
                placeholder="Phone number"
                className="w-full px-4 py-3 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button 
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-semibold transition-colors whitespace-nowrap"
              >
                Request Access to Off-Market Listings
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}